import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { suspiciousActivityInfoValidate } from '../../../../../../hooks'

export const Identification = () => {
  const { control } = useFormContext<SarEdit>()
  return (
    <Controller
      name="suspiciousActivityInfo.identification"
      control={control}
      rules={{
        validate: suspiciousActivityInfoValidate
      }}
      render={({ field }) => (
        <FF2
          field={field}
          label="37. Identification/Documentation"
          input={(props) => (
            <CheckBoxGroup
              {...props}
              data-qa={'37. Identification/Documentation'}
              direction={'vertical'}
              data={[
                { label: 'a. Changes spelling or arrangement of name', value: 'a' },
                { label: 'b. Multiple individuals with same or similar identities', value: 'b' },
                { label: 'c. Provided questionable or false documentation', value: 'c' },
                { label: 'd. Provided questionable or false identification', value: 'd' },
                { label: 'e. Refused or avoided request for documentations', value: 'e' },
                { label: 'f. Single individual with multiple identities', value: 'f' },
                { label: 'z. Other', value: 'z' }
              ]}
            />
          )}
        />
      )}
    />
  )
}
